import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: Root,
});

function Root() {
  // Auth is gated at the root route; once signed in the default landing is the
  // hosts/terminal workspace.
  return <Navigate to="/hosts" replace />;
}
